<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <div class="table-wrapper h-100 d-flex flex-column">
        <div class="filter-block">
          <SearchInput :search-change="searchChange" />
          <div class="action-buttons-wrapper">
            <b-button
              v-b-modal="`add-apiKey-modal`"
              variant="primary"
              size="lg"
              class="pl-3 pr-4 d-flex align-items-center"
            >
              <BIconPlus class="mr-2" />
              {{ `Add API key` | i18n }}
            </b-button>
            <AddAPI :get-page="getPage" />
            <b-button
              variant="outline-danger"
              size="lg"
              class="ml-3 pl-4 pr-4 d-flex align-items-center"
              :disabled="!selectedList.length"
              @click="deleteInstance"
            >
              <img :src="deleteIconUrl" class="mr-2" />
              {{ `Remove API key` | i18n }}
            </b-button>
          </div>
        </div>
        <Table
          :update="getPage"
          :columns="c"
          :rows="rows"
          :filter="filter"
          :update-filter="updateFilter"
          :loading-instance="loadingInstance"
          :set-loading-instance="setLoadingInstance"
          :selected-list="selectedList"
          :set-selected-list="setSelectedList"
          class="overflow-auto pr-1"
          tableName="apiManagementTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BIconPlus } from 'bootstrap-vue';

import { DeleteRowMixin, NotificationMixin, ApiManagementMixin } from '../../../../mixins';
import PageHeader from '../../common/page-header';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import DeleteIcon from '../../../../assets/icons/delete.svg';
import AddAPI from './add-api.vue';

let inputInterval = null;

export default {
  title: 'Instance',
  components: { PageHeader, BIconPlus, Table, SearchInput, AddAPI },
  mixins: [DeleteRowMixin, NotificationMixin, ApiManagementMixin],
  data() {
    return {
      deleteIconUrl: DeleteIcon,
      c: [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center',
        },
        {
          field: 'name',
          title: this.$translate('name'),
          key: '2',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'user',
          title: this.$translate('user'),
          key: '3',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <span>{row.user ? row.user.email : ''}</span>;
          },
        },
      ],
      selectedList: [],
      selectedInstance: {},
      loadingInstance: null,
      filter: {
        page: 1,
        limit: 20,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
      },
      rows: [],
    };
  },
  methods: {
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    async deleteInstance() {
      try {
        await this.deleteSelectedRows({}, async () => {
          const ids = this.selectedList.map((r) => r.id);
          await this.apiManagementService.remove({ ids });
          this.rows = this.rows.filter((i) => !ids.includes(i.id));
          this.selectedList = [];
          this.getPage();
        });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        const response = await this.apiManagementService.get(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  margin: 0 10px;
  cursor: pointer;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
}

::v-deep .action-block {
  display: flex;
  justify-content: center;
}

::v-deep .action-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.action-buttons-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-buttons-wrapper button {
  white-space: nowrap;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
